import { Module } from "../../ui/components/Module";
import { NotFound } from "./NotFound";

export const ModuleNotFound = () => {
  return (
    <Module>
      <NotFound/>
    </Module>
  );
};
